// extracted by mini-css-extract-plugin
export default {"readMore":"SHjEQek4","mobile":"mobile","title":"yV6Y6skT"};